export default __webpack_public_path__ + "static/media/rinki.26970800.jpg";